"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6372 4H12v2h2.6372l1.3819 9.3278c-.8975.4197-1.5875 1.2091-1.8742 2.1722H9.8551C9.4248 16.0543 8.0855 15 6.5 15 4.567 15 3 16.567 3 18.5S4.567 22 6.5 22c1.5855 0 2.9248-1.0543 3.355-2.5h4.2899c.4303 1.4457 1.7696 2.5 3.3551 2.5 1.933 0 3.5-1.567 3.5-3.5 0-1.7641-1.3051-3.2233-3.0024-3.4649l-1.382-9.3282C16.4704 4.7262 15.6286 4 14.6372 4zM6.5 20c.8284 0 1.5-.6716 1.5-1.5S7.3284 17 6.5 17 5 17.6716 5 18.5 5.6716 20 6.5 20zM19 18.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5z"
  })];
};

exports.default = _default;